import { Modal, Fab, Box } from '@mui/material'
import { Close, Undo } from '@mui/icons-material'
import { styleModal } from '../../config'
import { useSystemContext } from '../../context'

const VersionControlModal = ({ open, closeModal }) => {
    const { frontendVersion } = useSystemContext()
    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styleModal}>
                <div style={{ textAlign: 'left', width: '100%' }}>
                    <h2>Versión {frontendVersion}</h2>
                    <p>La presente actualización se enfoca en optimizar la usabilidad y robustecer las validaciones de datos, integrando mejoras basadas en el feedback de los usuarios para resolver incidencias puntuales y elevar la precisión del sistema.</p>
                </div>

                <div style={{ width: '100%', height: '50vh', overflowY: 'auto', textAlign: 'left' }}>
                    <strong>Funcionalidad y Lógica de Negocio</strong>
                    <li>
                        <strong>Gestión de Avances:</strong> Se optimizó el sistema de desmarcaje de checks independiente al estado de ejecución, garantizando un recalculo exacto del avance.
                    </li>
                    <li>
                        <strong>Reportes Obligatorios:</strong> Para asegurar la calidad de la información, ahora es obligatorio adjuntar una imagen al crear nuevos hallazgos.
                    </li>
                    <li>
                        <strong>Validaciones Dinámicas:</strong> Nuevo sistema de control de errores mediante notificaciones y modales interactivos en el proceso de creación de reportes.
                    </li>

                    <br />
                    <strong>Mejoras en Reportes y OT</strong>
                    <li>
                        <strong>Reporte Resumen de Hallazgos:</strong> Actualización del formato de fechas y rediseño de interfaz para hallazgos con y sin imagen.
                    </li>
                    <li>
                        <strong>Métricas de Horas:</strong> Integración de una tabla de horas efectivas dentro del reporte resumido y uso del horómetro del reporte para mayor precisión.
                    </li>
                    <li>
                        <strong>Flujo de Aprobación Unificado:</strong> Los estados de aprobación, rechazo y generación de PDF ahora utilizan un único modal de notificación consistente.
                    </li>

                    <br />
                    <strong>Interfaz y UX (User Experience)</strong>
                    <li>
                        <strong>Acceso Simplificado (Login):</strong> Ingreso por RUT estrictamente numérico (sin guion) y con límite de caracteres para evitar errores.
                    </li>
                    <li>
                        <strong>Formularios Técnicos:</strong> El campo &ldquo;Término de jornada&rdquo; ha sido renombrado a &ldquo;Cantidad total de mantenedores&rdquo; para mayor claridad.
                    </li>
                    <li>
                        <strong>Optimización de Alertas:</strong> Eliminación de confirmaciones redundantes en la asignación de reportes del módulo Origin.
                    </li>

                    <br />
                    <hr />
                    <br />
                    <strong>Historial de Versiones</strong>
                    <br />
                    <strong>v4.0.7</strong>
                    <li>
                        Implementación de un nuevo sistema de notificaciones y gestión de estados de lectura para noticias.
                    </li>
                    <li>
                        Optimización en la creación de reportes, corrigiendo la sincronización de obras y actividades.
                    </li>
                    <li>
                        Mejoras en la experiencia de usuario: cierre automático de la barra de navegación y carga optimizada de roles.
                    </li>
                    <br />
                    <strong>v4.0.5</strong>
                    <li>
                        Optimización del sistema de desmarcaje de checks y recalculo de avance.
                    </li>
                    <li>
                        Obligatoriedad de imágenes en la creación de hallazgos.
                    </li>
                    <li>
                        Nuevo sistema de validación con modales dinámicos.
                    </li>
                    <li>
                        Rediseño del reporte resumen de hallazgos y unificación de flujo de aprobación.
                    </li>
                    <li>
                        Login por RUT numérico y renombrado de campos en formularios de jornada.
                    </li>
                    <li>
                        Uso del horómetro del reporte en lugar del de la máquina para métricas precisas.
                    </li>
                    <br />
                    <strong>v4.0.1</strong>
                    <li>
                        Paridad del estado &rsquo;Completada&rsquo; para el Nivel 4 en el flujo de reportes.
                    </li>
                    <li>
                        Mejoras en la descarga de resúmenes y lógica de generación de PDFs.
                    </li>
                    <li>
                        Introducción de cálculo de &rsquo;horas efectivas&rsquo; en el resumen de la OT.
                    </li>
                    <li>
                        Gestión mejorada de imágenes y backlogs en modo offline.
                    </li>
                    <li>
                        Refactorización de llamadas a reportes paginados para optimizar la carga.
                    </li>
                    <br />
                    <strong>v4.0.0</strong>
                    <li>
                        <strong>Control de Jornada:</strong> Validación obligatoria de cierre de jornada al iniciar/terminar sesión para operadores.
                    </li>
                    <li>
                        <strong>Operación Colaborativa:</strong> Soporte multi-operador en una misma OT y función de cámara nativa integrada.
                    </li>
                    <li>
                        <strong>Vistas Personalizadas:</strong> Configuración de columnas visibles en el listado de reportes según preferencia del usuario.
                    </li>
                    <li>
                        <strong>Modelos 3D:</strong> Visualización avanzada de subsistemas y etiquetado técnico de maquinaria.
                    </li>
                    <br />
                    <strong>v2.9.3</strong>
                    <li>
                        Se deshabilita actualización de app por medio de vertical scrolling.
                    </li>
                    <br />
                    <strong>v2.9.2</strong>
                    <li>
                        Se corrige error de asignación de usuarios y botón de sincronización.
                    </li>
                    <br />
                    <strong>v2.9.1</strong>
                    <li>
                        Corrección de errores
                    </li>
                    <br />
                    <strong>v2.9</strong>
                    <li>
                        Se mejora el rendimiento y repara errores de bugs producto de
                    </li>
                    <br />
                    <strong>v2.6.4</strong>
                    <li>
                        Cambios en Pautas. Ahora se pueden eliminar comentarios, fotos y el estado de ticket verde o amarillo a vacío en caso de error.
                    </li>
                    <li>
                        Se aplican filtros en OT de maquinaria.
                    </li>
                    <li>
                        Otras modificaciones menores.
                    </li>
                    <br />
                    <strong>v2.6.3</strong>
                    <li>
                        Se permite el borrado de mensajes a usuarios que crean los mensajes o Admins
                    </li>
                    <li>
                        Se agrega nueva vista de resumen de insumos o materiales, para ejecutivos SAP o Administradores
                    </li>
                    <strong>v2.6.2</strong>
                    <li>
                        Reparación visualización de pautas
                    </li>
                    <li>
                        Se agrega en opciones un botón para ver las pautas descargadas en el dispositivo
                    </li>
                    <br />
                    <strong>v2.6.1</strong>
                    <li>
                        Se genera vista previa de la OT para Ejecutivo SAP y los administradores
                    </li>
                    <li>
                        Se crea botón de eliminación de mensajes de tareas para OTs
                    </li>
                    <br />
                    <strong>v2.6</strong>
                    <li>
                        Reparación errore de carga de datos
                    </li>
                    <br />
                    <strong>v2.5.5</strong>
                    <li>
                        Nueva máquina Bulldozer Caterpillar D10-T2
                    </li>
                    <br />
                    <strong>v.2.5</strong>
                    <li>
                        Nuevas Obras y Nuevas máquinas.
                    </li>
                    <br />
                    <strong>v.2.3.1</strong>
                    <li>
                        Reparaciones menores en lista de Ordenes
                    </li>
                    <br />
                    <strong>v.2.3.1</strong>
                    <li>
                        Error de login con R.U.N. resuelto
                    </li>
                    <br />
                    <strong>v.2.3</strong>
                    <br />
                    <strong>Documentos PDF</strong>
                    <li>
                        Se agrega Nro de Pauta en título de la OT
                    </li>
                    <li>
                        Se agrega ID de Documento
                    </li>
                    <li>
                        Se corrige nombre de la pauta al descargar
                    </li>
                    <strong>Página Ordenes</strong>
                    <li>
                        Se agrega primeros filtros (ordenar por OT y ordenar por Nro de Máquina)
                    </li>
                    <li>
                        Se puede corregir número SAP desde ventana emergente al presionar votón <button style={{ backgroundColor: '#F9F9F9', borderRadius: 20, borderColor: '#757575', maxWidth: 130, height: 24, fontSize: 12 }}>Ver</button>
                    </li>
                    <strong>Máquinas</strong>
                    <li>
                        Al ingresar a cada máquina, en el listado de las OT, puede ver un <a href='#'>Enlace Documento</a> en caso de existir documento PDF creado.
                    </li>
                    <strong>Login</strong>
                    <li>
                        Login por defecto queda por R.U.N.
                    </li>
                    <br />
                    <strong>v.2.2.1</strong>
                    <li>
                        Reparación de errores generados en versión 2.2
                    </li>
                    <strong>v.2.2</strong>
                    <li>
                        Se habilita multiusuarios.
                    </li>
                    <strong>v.2.1</strong>
                    <li>
                        Corrección de errores al cierre de OT.
                    </li>
                    <li>
                        Todo usuario que no sea operario, obtendrá la pauta desde la base de datos. Con esto se espera que se elimine la información.
                    </li>
                    <p>Se ha actualizado la aplicación de servicios de Mantenimiento e Inspección.</p>
                    <strong>v.2.0</strong>
                    <li>
                        Se agrega al servicio sistema de búsqueda por Nombre, Rut y Correo Electrónico
                    </li>
                    <li>
                        Se elimina la posibilidad al Jefe de Maquinaria la posibilidad de comentar.
                    </li>
                    <li>
                        Se agrega al servicio restaurador de datos de ejecución de OT desde la cuenta
                        de Operador o Mantenedor, utilizando botón <strong>Restaurar</strong>.
                    </li>
                    <div
                        style={
                            {
                                width: '100%',
                                textAlign: 'center'
                            }
                        }
                    >
                        <Fab color="primary" aria-label="add">
                            <Undo />
                        </Fab>
                    </div>
                    <div
                        style={
                            {
                                borderBottomWidth: 1,
                                borderBottomStyle: 'solid',
                                borderBottomColor: '#ccc',
                                paddingTop: 0,
                                marginBottom: 50
                            }
                        }
                    >

                    </div>
                    <strong>v.1.9.9</strong>
                    <li>
                        Modificaciones en vistas de Ordenes.
                    </li>
                    <li>
                        Se habilita vista de Ordenes para Jefe de Maquinaria. Este perfil no puede generar nuevo documento PDF por estar
                        fuera del flujo de actualizaciones de la OT.
                    </li>
                    <strong>v.1.9.8</strong>
                    <li>
                        Reparación de fallos al subir las AST.
                    </li>
                    <strong>v.1.9.7</strong>
                    <li>
                        Reparación de fallos PDF.
                    </li>
                    <strong>v.1.9.6</strong>
                    <li>
                        Inserta imágenes de comentarios en PDF.
                    </li>
                    <strong>v.1.9.5</strong>
                    <li>
                        Cambios en la generación del documento PDF. Ahora se crea automáticamente al cerrar la OT por parte del Ejecutivo SAP, Admin o Super Admin.
                    </li>
                    <li>
                        Listado de OTs en página Ordenes, ordenados por Nro OT.
                    </li>
                    <strong>v.1.9</strong>
                    <li>
                        Se integra servicio Storage para imágenes de la plataforma.
                    </li>
                    <strong>v.1.8.9</strong>
                    <li>
                        Cambios en forma de llenado de pauta, presionando el checkbox.
                    </li>
                    <li>
                        Mejoras de rendimiento.
                    </li>
                    <strong>v.1.8.8</strong>
                    <li>
                        Reparación de notificaciones.
                    </li>
                    <li>
                        Vista notificaciones de página de inicio se actualiza junto a la llegada de notificaciones push.
                    </li>
                    <strong>v.1.8.7</strong>
                    <li>
                        Cambios en los permisos de roles.
                    </li>
                    <li>
                        Correo para creación de usuarios opcional.
                    </li>
                    <strong>v.1.8.6</strong>
                    <li>
                        Se agrega login usando RUT.
                    </li>
                    <li>
                        Reparaciónes menores.
                    </li>
                    <strong>v.1.8.5</strong>
                    <li>
                        Reparaciones menores.
                    </li>
                    <strong>v.1.8</strong>
                    <li>
                        Modelo 3D de subsistema desde la OT.
                    </li>
                    <li>
                        Etiquetado de Pala y Camión.
                    </li>
                    <strong>v.1.7</strong>
                    <li>
                        Se posicionan etiquetas de Pala y Camión de acuerdo a indicaciones.
                    </li>
                    <strong>v.1.6</strong>
                    <li>
                        Se habilita vista 3D de máquinas. Solo cambión Caterpillar 793-F cuenta con etiquetas en las partes.
                    </li>
                    <li>
                        Se habilita botón de borrado del sistema en caso de requerir limpiar la memoria.
                    </li>
                    <strong>v.1.5</strong>
                    <li>
                        Se agrega elemento que permite borrar o cambiar la AST.
                    </li>
                    <strong>v.1.4</strong>
                    <li>
                        Optimizaciones. Cambios al proceso de flujo. Se corrige error al enviar OT finalizando sin conexión.
                    </li>
                    <strong>v.1.3</strong>
                    <li>
                        Ajustes de usuarios. Corrección en caso de cambios para la AST.
                    </li>
                    <li>
                        Corrección de errores.
                    </li>
                    <strong>v.1.2</strong>
                    <li>
                        Cambios de vistas. Se agrega foto AST en pautas.
                    </li>
                    <strong>v.1.1</strong>
                    <li>
                        Se agrega listado de OTs asignadas a cada máquina.
                    </li>
                    <li>
                        Se ajustan cambios en pautas.
                    </li>
                    <br />
                    <strong>v.1.0</strong>
                    <li>
                        Habilitado producción.
                    </li>
                </div>
                <Fab onClick={() => closeModal()} style={{ position: 'absolute', right: 10, top: 10, boxShadow: 'none', backgroundColor: 'transparent' }}>
                    <Close style={{ color: '#ccc' }} />
                </Fab>
            </Box>
        </Modal>
    )
}

export default VersionControlModal
